/**
 * 商城相关页面的路由
 */
const mallRouter = [
  {
    path: `/mall/detail`,
    component: () => import(`@/views/detailspage/morestore`),
    name: `ProductDetail`,
    meta: { title: '产品详情', auth: false },
  },
  {
    path: '/mall/company',
    component: () =>
      import('@/views/detailspage/shopintroduction/moreintroduction'),
    name: 'Company',
    meta: { title: '企业介绍', auth: false },
  },

  {
    path: '/mall/shop',
    component: () => import('@/views/detailspage/shophome'),
    name: 'Shop',
    meta: { title: '店铺介绍', auth: false },
  },

  {
    path: '/mall/cart',
    component: () => import('@/views/shopcart'),
    name: 'Cart',
    meta: { title: '购物车', auth: true },
  },
  {
    path: '/mall/add-address',
    component: () => import('@/views/orderpage/addreceivingaddress'),
    name: 'AddAddress',
    meta: { title: '添加地址', auth: true },
  },
  {
    path: '/mall/editaddress',
    component: () => import('@/views/orderpage/editaddress'),
    name: ' EditAddress',
    meta: { title: '编辑地址', auth: true },
  },
  {
    path: '/mall/myaddress',
    component: () => import('@/views/orderpage/myaddress'),
    name: ' MyAddress',
    meta: { title: '我的地址', auth: true },
  },

  {
    path: '/mall/order-confirm',
    component: () => import('@/views/orderpage/confirmation'),
    name: 'OrderConfirm',
    meta: { title: '确认订单', auth: true },
  },
  {
    path: '/mall/order-carthomeconfirmation',
    component: () => import('@/views/orderpage/carthomeconfirmation'),
    name: 'OrderCartHome',
    meta: { title: '确认订单', auth: true },
  },
  {
    path: '/mall/order-cartfastmail',
    component: () => import('@/views/orderpage/cartfastmail'),
    name: 'OrderCartFastmail',
    meta: { title: '确认订单', auth: true },
  },
  {
    path: '/mall/order-nowpayexpress',
    component: () => import('@/views/orderpage/nowpayexpress'),
    name: 'OrderNowPayExpress',
    meta: { title: '确认订单', auth: true },
  },

  {
    path: '/mall/order',
    component: () => import('@/views/themepage/order'),
    name: 'Order',
    meta: { title: '我的订单', auth: true },
  },

  {
    path: '/mall/order-detail',
    component: () => import('@/views/themepage/orderdetail'),
    name: 'Detail',
    meta: { title: '订单详情', auth: false },
  },
  {
    path: '/mall/order-wuliudetail',
    component: () => import('@/views/themepage/orderdetailofwuliu'),
    name: 'DetailWuliu',
    meta: { title: '订单详情', auth: false },
  },
  {
    path: '/mall/order-intracityservice',
    component: () => import('@/views/themepage/Intracityservice'),
    name: 'DetailTongcheng',
    meta: { title: '订单详情', auth: false },
  },
  {
    path: '/themepage/success',
    component: () => import('@/views/themepage/success'),
    name: 'PaySuccess',
    meta: { title: '支付成功', auth: false },
  },

  {
    path: '/themepage/error',
    component: () => import('@/views/themepage/error'),
    name: 'PayError',
    meta: { title: '支付失败', auth: false },
  },
  {
    path: '/themepage/PaymentTransition',
    component: () => import('@/views/themepage/PaymentTransition'),
    name: 'PayError',
    meta: { title: '支付选择', auth: false },
  },
  // 扶贫页商城相关
  {
    path: '/themepage/index',
    component: () => import('@/views/themepage/index'),
    name: 'SupportPoor',
    meta: { auth: false },
  },
  {
    path: '/themepage/hbsubject',
    component: () => import('@/views/themepage/hbsubject'),
    name: 'Advertisement',
    meta: { auth: false },
  },
  {
    path: '/help-mall/detail',
    component: () => import('@/views/payproduct/productdetaile'),
    name: 'HelpMallDetaile',
    meta: { title: '产品详情', auth: false },
  },
  {
    path: '/help-mall/order-nowpayexpress',
    component: () => import('@/views/payproduct/nowpayexpress'),
    name: 'HelpMallNowpayExpress',
    meta: { title: '确认订单', auth: false },
  },
  {
    path: '/help-mall/order-confirmation',
    component: () => import('@/views/payproduct/confirmation'),
    name: 'HelpMallConfirmation',
    meta: { title: '确认订单', auth: false },
  },
  {
    path: '/help-mall/order-newaddress',
    component: () => import('@/views/payproduct/newaddress'),
    name: 'HelpMallNewaddress',
    meta: { title: '添加地址', auth: false },
  },
  {
    path: '/mycoupon',
    component: () => import('@/views/personalcenter/mycoupon'),
    name: 'Mycoupon',
    meta: { title: '我的劵', auth: false },
  },
  {
    path: '/product-coupon',
    component: () => import('@/views/personalcenter/couponlist'),
    name: 'ProductCoupon',
    meta: { title: '劵可用产品', auth: false },
  },
  {
    path: '/store-list',
    component: () => import('@/views/homepage/puhuishangcheng/result'),
    name: 'StoreList',
    meta: { title: '商家列表', auth: false },
  },
];

export default mallRouter;
